var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.canContactTeam
    ? _c(
        "div",
        [
          _vm.rm && _vm.displayedModal
            ? _c("ContactTeamModal", {
                attrs: {
                  item: _vm.rm,
                  "modal-key": "contactRM",
                  "header-class": "rm-bg"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.am && _vm.displayedModal
            ? _c("ContactTeamModal", {
                attrs: {
                  item: _vm.am,
                  "modal-key": "contactAM",
                  "header-class": "am-bg"
                }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }